import { SegmentParams } from './composeSegmentParams';
import { composeTimeSelectParams } from './composeTimeSelectParams';
import { isAgeSelectorEnabled } from '../../utils/AgeSelectorUtils';

export const INFANT_MAX_AGE = 1;

const composePaxParams = (trainPax, trainPaxAges) => {
    const { seniors, adults, youth } = trainPax;
    let url = '';
    let children = 0;
    let infants = 0;
    if (isAgeSelectorEnabled()) {
        ({ children, infants } = trainPaxAges.childrenAges.reduce(
            ({ children, infants }, { age }) => {
                if (age > INFANT_MAX_AGE) return { children: children + 1, infants };
                return { children, infants: infants + 1 };
            },
            { children: 0, infants: 0 },
        ));
    } else {
        children = trainPax.children || 0;
        infants = trainPax.infants || 0;
    }
    if (adults + seniors + youth > 0) {
        url += `;adults=${adults + seniors + youth}`;
    }
    if (children > 0) {
        url += `;children=${children}`;
    }
    if (infants > 0) {
        url += `;infants=${infants}`;
    }
    return url;
};

// eslint-disable-next-line complexity
const composeAgeParams = (trainPax, trainPaxAges) => {
    const DEFAULT_AGE_ADULTS = 30;
    const DEFAULT_AGE_SENIORS = 60;
    const DEFAULT_AGE_CHILDREN = 10;
    const DEFAULT_AGE_INFANTS = 1;
    const { seniors, adults, youth } = trainPax;
    let url = '';
    let adultAges = '';
    let childrenAges = '';
    let infantAges = '';
    if (adults > 0 || seniors > 0 || youth > 0) {
        const seniorsArray = new Array(seniors).fill(DEFAULT_AGE_SENIORS);
        const adultsArray = new Array(adults).fill(DEFAULT_AGE_ADULTS);
        const youthArray = trainPaxAges.youthAges.map(({ age }) => age);
        const adultAgesArray = [...seniorsArray, ...adultsArray, ...youthArray];
        adultAges = `;adultAges=${adultAgesArray.join('-')}`;
    }

    if (isAgeSelectorEnabled()) {
        const { childrenArray, infantsArray } = trainPaxAges.childrenAges.reduce(
            ({ childrenArray, infantsArray }, { age }) => {
                if (age > INFANT_MAX_AGE) return { childrenArray: [...childrenArray, age], infantsArray };
                return { childrenArray, infantsArray: [...infantsArray, age] };
            },
            { childrenArray: [], infantsArray: [] },
        );

        if (childrenArray.length > 0) {
            childrenAges = `;childrenAges=${childrenArray.join('-')}`;
        }
        if (infantsArray.length > 0) {
            infantAges = `;infantAges=${infantsArray.join('-')}`;
        }
    } else {
        const childrenCount = trainPax.children || 0;
        const infantsCount = trainPax.infants || 0;
        if (childrenCount > 0) {
            childrenAges = `;childrenAges=${new Array(childrenCount).fill(DEFAULT_AGE_CHILDREN).join('-')}`;
        }
        if (infantsCount > 0) {
            infantAges = `;infantAges=${new Array(infantsCount).fill(DEFAULT_AGE_INFANTS).join('-')}`;
        }
    }
    url += `${adultAges}${childrenAges}${infantAges}`;
    return url;
};

export const composeTrainsParams = (search) => {
    const { isDirect, segments, trainPax = {}, trainPaxAges = { childrenAges: [], youthAges: [] }, airlineFilter } = search;
    let url = SegmentParams.compose(search);

    if (isDirect) {
        url += ';direct=true';
    }

    url += composePaxParams(trainPax, trainPaxAges);
    url += composeAgeParams(trainPax, trainPaxAges);
    url += composeTimeSelectParams(segments);

    if (airlineFilter && airlineFilter.enabled) {
        url += `;airlinescodes=${airlineFilter.airlineIata}`;
    }

    return url;
};
